import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';
import { updateNavbarState } from './navbar_actions';

export const SPOT_PURCHASES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('SPOT_PURCHASES');
const SPOT_PURCHASES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SPOT_PURCHASES_CRUD_ACTION_CONSTANTS
);

const originalFn = SPOT_PURCHASES_CRUD_ACTION_CREATORS.updateSuccess;
SPOT_PURCHASES_CRUD_ACTION_CREATORS.updateSuccess = function (entity) {
	return function (dispatch, getState) {
		const { navbar } = getState();
		if (navbar && navbar.backlinkTo) {
			const { backlinkTitle, navbarBackgroundColor } = navbar;
			const [path, queryParams] = navbar.backlinkTo.split('?');
			const urlSearchParams = new URLSearchParams(queryParams);
			urlSearchParams.delete('preserve');
			const backlinkTo = `${path}?${urlSearchParams.toString()}`;
			dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor));
		}
		dispatch(originalFn(entity));
	};
};
export { SPOT_PURCHASES_CRUD_ACTION_CREATORS };
